/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit RetailItems/view.blocks to change it.
import * as fromData from 'Simple/Data'
import AddAction from './AddAction/index'
import React from 'react'
import RetailItem from './RetailItem/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'
import styles from './view.module.css'
import useListItemDataOnChange from './useListItemDataOnChange.js'



/** @type {import('Simple/types.js').View} */
export default function RetailItems({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsCreateInvoice/RetailItems"
  
}) {
let createInvoiceRetailItemsValueData = fromData.useDataValue({ viewPath,
context: 'create_invoice',
path: 'retail_items',
})
  return (<React.Fragment
>
<div
  data-testid="RetailItems.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaInputLabel
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Retail items"
/>
<AddAction
  viewPath={`${viewPath}/AddAction`}
/>
</div>
<div
  data-testid="RetailItems.List"
  data-view-path={viewPath}
 className={`views-block ${styles.List}`}
>
{Array.isArray(createInvoiceRetailItemsValueData) && createInvoiceRetailItemsValueData.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="retail_item"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/RetailItem(${item?.id ?? item?._id ?? index})`}
      >
<RetailItem
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/RetailItem(${item?.id ?? item?._id ?? index})`}
/>
</ListItem>
)}
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    let onChange = useListItemDataOnChange({ ...props, viewPath: props.parentViewPath })
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      onChange={onChange}
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }